<template>
  <div>
    <div class="white-section mb-2">
      <b-form @submit.prevent class="mt-0">
        <b-row>
          <b-col md="4">
            <b-form-group
                :label="$t('section.sectionTitle')"
                label-for="section-title"
                :invalid-feedback="
            invalidFeedbackTitle
              ? $t(`validation.${invalidFeedbackTitle}`, {
                  field: $t('section.sectionTitle'),
                })
              : ''
          "

            >
              <b-form-input autofocus
                            id="section-title"
                            :state="$v.sectionToEdit.title.$dirty ? !$v.sectionToEdit.title.$invalid : null"
                            v-model="sectionToEdit.title"
                            v-on:keyup.enter="onEnter"

              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group :label="$t('general.status')" label-for="section-status">
              <b-form-select
                  text-field="text"
                  value-field="value"
                  v-model="sectionToEdit.status"
                  :options="statuses"
                  id="section-status"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>

    <div class="white-section">
      <b-col md="12" class="text-right">
        <b-button
            size=""
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="info"
            class="col-12"
            @click="editSection"
        >
          {{ $t("general.submit") }}
        </b-button>
      </b-col>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import Ripple from "vue-ripple-directive";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormSelect,
  BFormInvalidFeedback, BBreadcrumb,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
export default {
  mounted() {
  },
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
    BFormInvalidFeedback,
    BBreadcrumb,
  },
  data() {
    return {
      items: [
        {
          text: this.$t('section.sections'),
          to: {name : 'manageSection'}
        },
        {
          text: this.$t('section.editSection'),
          active: true
        }
      ]
    }
  },
  validations() {
    return {
      sectionToEdit: {
          title: {
            required,
          },
      }
    };
  },
  computed: {
    invalidFeedbackTitle: {
      set(error) {},
      get() {
        let  error = "";
        if (!this.$v.sectionToEdit.title.$dirty) return error;
        if (!this.$v.sectionToEdit.title.required) error = "required";
        return error;
      },
    },
    ...mapGetters({
      statuses: "general/statuses",
    }),
    sectionToEdit: {
      set(sectionToEdit) {
        this.$store.commit("sections/SET_SECTION_TO_EDIT", sectionToEdit);
      },
      get() {
        return this.$store.getters["sections/sectionToEdit"];
      },
    },
    
  },
  methods: {
    onEnter(){
      this.editSection()
    },
    editSection() {
        const payload = {
          title: this.sectionToEdit.title,
          status: this.sectionToEdit.status,
        };
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.commit('SET_IS_LOADING', true)
        this.$store
            .dispatch("sections/updateSection", {
              id: this.sectionToEdit._id,
              payload: payload,
            })
            .then(() => {
              this.$store.commit('SET_IS_LOADING', false)
              this.$bvToast.toast(this.$t('toastification.submissionSucceed'), {
                title: this.$t('toastification.success'),
                variant: 'success',
                solid: true,
              });
              this.$router.push({name: "manageSection"});
            })
            .catch((error) => {
              let msg = '';
              switch (error.response.status){
                case 422:
                  msg = this.$t('toastification.duplicatedData');
                  break;
                case 404:
                  msg = this.$t('toastification.notFound');
                  break;
              }
              this.$bvToast.toast(msg, {
                title: this.$t('toastification.error'),
                variant: 'danger',
                solid: true,
              });
              this.$store.commit('SET_IS_LOADING', false)
            });
      }else{
        this.$nextTick(() => {
        const el = document.querySelector(".is-invalid:first-of-type");
        
        el.scrollIntoView({ behavior: 'instant', block: 'center' });
        // el.scrollIntoView();
        return;
        })
      }
    },
  },
  created() {
      let params = this.$route.params;
      this.$store.dispatch('sections/getSectionToEdit', params.id).then(res=>{
        this.pushBreadcrumb({text: 'editSection', to:{name:'editSection' }, translate:true});
        this.pushBreadcrumb( {text: res[0].title , translate:false});
        this.setCurrentBreadcrumb([{text: 'editSection', to:{name:'editSection' }, translate:true},{text: res[0].title , translate:false} ]);
      })
  },
};
</script>